<template>
  <div
    class="company-block company-block-trainings mb-2"
    :class="{
      selected: isSelected,
    }"
    :disabled="registrationsCount == maximumCapacity"
    @click.stop.prevent="setSelectedSession"
  >
    <div class="select-training-list">
      <div class="d-flex align-items-center">
        <span class="mr-1 icon icon-calendar" />{{ startAt }}
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <span class="mr-1 icon icon-baloon" v-if="locationName" />{{
          locationName
        }}
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <span
          :class="
            sessionsAviable
              ? 'mr-1 icon icon-trainee-danger'
              : 'mr-1 icon icon-trainee-gray'
          "
        />{{ registrationsCount }}/
        {{ maximumCapacity }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "SessionsRow",
  props: {
    session: {
      required: true,
      type: Object,
    },
    index: {
      required: false,
      default: 0,
    },
    selectedSession: {
      required: true,
    },
  },
  computed: {
    ...mapFields(["user"]),
    isSelected() {
      return this.selectedSession && this.session.id == this.selectedSession.id;
    },
    traineesNumber() {
      return this.total;
    },
    locationName() {
      return this.$lodash.get(this.session, "locationName", "--");
    },
    startAt() {
      if (this.$moment(this.session.startAt).isValid()) {
        return this.$moment(this.session.startAt).format("DD.MM.YYYY");
      } else return "--";
    },
    sessions() {
      if (this.selectedTraining) {
        return this.selectedTraining.sessions.data;
      }
      return [];
    },
    registrationsCount() {
      if (this.$lodash.get(this.session, "registrationsCount", false)) {
        let registrationsCount = this.session.registrationsCount;
        return registrationsCount;
      } else {
        return 0;
      }
    },
    maximumCapacity() {
      let maximumCapacity = 0;
      if (this.$lodash.get(this.session, "maximumCapacity", false)) {
        maximumCapacity = this.session.maximumCapacity;
      }
      return maximumCapacity;
    },
    sessionsAviable() {
      let registrationsCount = this.$lodash.get(
        this.session,
        "registrationsCount",
        false
      );
      let maximumCapacity = this.$lodash.get(
        this.session,
        "maximumCapacity",
        false
      );
      if (registrationsCount && maximumCapacity) {
        if (registrationsCount >= maximumCapacity) return false;
        else return true;
      }
    },
  },
  methods: {
    setSelectedSession() {
      this.$bus.$emit("update-selected-session", this.session);
    },
  },
};
</script>

<style></style>
